import { render } from "./UploadContent.vue?vue&type=template&id=50539afe&scoped=true"
import script from "./UploadContent.vue?vue&type=script&lang=js"
export * from "./UploadContent.vue?vue&type=script&lang=js"

import "./UploadContent.vue?vue&type=style&index=0&id=50539afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50539afe"]])

export default __exports__